import http from '@/api/common'

export default {
  getSurveysByLocation (params) {
    return http.get('audit/getbylocation', { params })
  },
  getSurveysAssignedToUser (params) {
    return http.get('audit/getassignedtouser', { params })
  },
  getSurveyTypes (params) {
    return http.get('audit/getaudittypes', { params })
  },
  getSurvey (id) {
    return http.get(`audit/get?id=${id}`)
  },
  getSurveyByKey ({ key, userId }) {
    return http.get(`audit/getbykey?key=${key}&userId=${userId}`)
  },
  assignSurvey (survey) {
    return http.post('audit/create', survey)
  },
  updateSurvey (survey) {
    return http.post('audit/update', survey)
  },
  uploadSurveyPhoto (formData) {
    return http.post('audit/uploadphoto', formData)
  },
  deleteSurveyPhoto ({ surveyId, questionId, filename }) {
    return http.post(`audit/deletephoto?surveyId=${surveyId}&questionId=${questionId}&filename=${filename}`)
  },
  notifyAdminsSurveyIsComplete (surveyId) {
    return http.post(`audit/sendcompletionemail?surveyId=${surveyId}`)
  },
  getIncompleteSurveysCount () {
    return http.get('audit/getincompletesurveyscount')
  },
  getLaborAnalysis (locationId) {
    var param = typeof locationId !== 'undefined' ? `?locationId=${locationId}` : ''
    return http.get(`audit/getlaboranalysis${param}`)
  },
  sendReportByEmail ({ surveyKey, email }) {
    return http.get(`audit/sendreport?auditkey=${surveyKey}&email=${email}`)
  },
  updateBuildingNote ({surveyId, comment, isDefault}) {
    return http.post(`audit/updatebuildingnote?surveyId=${surveyId}&comment=${comment}&isDefault=${isDefault}`)
  },
  defaultBuildingNotes({surveyId, defaultYes}) {
    return http.post('')
  },
  getBuildingNotes (surveyId) {
    return http.get(`audit/GetBuildingNotes?surveyId=${surveyId}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/survey.js